export const SUPPORT_EMAIL = "admin@cestatech.com";

const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=LabGenesis%20support`;

export default function SupportContact({ compact = false }) {
  if (compact) {
    return (
      <div
        data-testid="support-contact"
        className="mx-3 mb-3 rounded-md border border-slate-200 bg-slate-50 px-3 py-2.5 text-xs text-slate-500"
      >
        <div className="font-semibold text-slate-700">Need help?</div>
        <a
          href={SUPPORT_MAILTO}
          className="mt-0.5 block break-all font-medium text-teal-700 hover:text-teal-900 hover:underline"
        >
          {SUPPORT_EMAIL}
        </a>
      </div>
    );
  }

  return (
    <div
      data-testid="support-contact"
      className="mt-8 border-t border-slate-200 pt-5 text-xs leading-relaxed text-slate-500"
    >
      Need help with LabGenesis? The primary support contact is{" "}
      <a
        href={SUPPORT_MAILTO}
        className="font-semibold text-teal-700 hover:text-teal-900 hover:underline"
      >
        {SUPPORT_EMAIL}
      </a>
      .
    </div>
  );
}
